import { StoryApiResponse } from 'api/api.types';
import KnowledgeLibrary from 'src/components/knowledge-library/KnowledgeLibrary';
import { GetServerSideProps, NextPage } from 'next';
import React from 'react';
import { KlList } from 'types/enums';
import { KNOW_LIB_STORIES_COUNT } from 'utils/constants';
import * as StoryApi from 'api/Story';
import { LatestList } from 'types/types';

interface OwnProps {
  data: LatestList<StoryApiResponse>;
}

const KnowledgeLibraryArticlesPage: NextPage<OwnProps> = ({ data }) => {
  return <KnowledgeLibrary currentSectionState={KlList.STORIES} data={data} />;
};
export const getServerSideProps: GetServerSideProps = async ({ params }) => {
  if (params && parseInt(params?.page as string) === 1) {
    return {
      redirect: {
        destination: '/stories',
        permanent: true,
      },
    };
  }

  let data: LatestList<StoryApiResponse> = {
    list: [],
    numberOfPages: 0,
  };

  const response = await StoryApi.getStories({
    offset:
      (params ? parseInt(params?.page as string) - 1 : 0) *
      KNOW_LIB_STORIES_COUNT,
  });

  if (response && response.objects) {
    data = {
      list: response.objects,
      numberOfPages: Math.ceil(
        response.meta.total_count / KNOW_LIB_STORIES_COUNT,
      ),
    };
  }

  // Return 404 for empty pages
  if (!data.list.length) {
    return { notFound: true };
  }

  return {
    props: { data },
  };
};

export default KnowledgeLibraryArticlesPage;
